var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"ma-2",attrs:{"small":_vm.payload.small,"large":_vm.payload.large,"x-small":_vm.payload.xSmall,"color":_vm.payload.color,"text-color":_vm.payload.textColor}},[_vm._v(" "+_vm._s(_vm.payload.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }